import React, {useEffect, useRef, useState} from 'react';
import myUserService from "../../../../services/web/my-user-service.js";
import {toast} from "react-toastify";
import AlertMessages from "../../../../components/messages/alert-message.js";
import projectUtils from "../../../../utils/project-utils.js";
import {Card} from "../../../../components/card/card.jsx";
import {FaArrowLeft, FaEnvelope} from "react-icons/fa";
import InputForm from "../../../../components/input/input-form.jsx";
import Button from "../../../../components/button/button.jsx";
import ResetRetryCountdown from "../../../../components/reset-retry-countdown/reset-retry-countdown.js";
import HandleHashInput from "../../../../components/handle-hash/input.js";
import HandleHashPaste from "../../../../components/handle-hash/paste.js";

let timerRunning = false;
let remainingSeconds = 30;

const MyUserEmail = ({email, setTarget, refetch, setIsLoading}) => {
    const [state, setState] = useState("");
    const [showHash, setShowHash] = useState(false);
    const [validated, setValidated] = useState(false);

    const resendBtn = useRef(undefined);
    const resendCode = useRef(undefined);
    const timerEl = useRef(undefined);
    const timer = useRef(undefined);
    const hashRef = useRef([]);

    useEffect(() => {
        setState(email ?? "");
        if (email) setValidated(true);

        return () => {
            setState("");
            setValidated(false);
            setShowHash(false);
        }
    }, [email]);

    const handleInput = ({target: {value}}) => {
        setState(value);
        setValidated(false);
    }

    const start_submit = () => {
        myUserService.validateEmail({email: state})
            .then(() => {
                setShowHash(true);
                ResetRetryCountdown(resendBtn, resendCode, timerEl, timerRunning, timer, remainingSeconds, start_submit);
            })
            .catch((error) => {
                console.error(error);

                const {message} = error.response.data;

                let errMessage = AlertMessages[message] ?? "Não foi possível prosseguir.";
                projectUtils.swalErrorMessage("", errMessage, "Ok");
            });
    }

    const submit = () => {
        const hash = [...hashRef.current].map(el => el.value).join("");

        setIsLoading(true)

        const formData = new FormData();
        formData.append("hash", hash);

        myUserService.updateEmail(formData)
            .then(() => {
                toast.success("Salvo com sucesso");
                setTarget("info");
                refetch();
            })
            .catch(error => {
                console.error(error);

                const {message} = error.response.data;

                let errMessage = AlertMessages[message] ?? "Não foi possível prosseguir.";
                projectUtils.swalErrorMessage("", errMessage, "Ok");
            })
            .finally(() => setIsLoading(false))
    }

    return (
        <>
            <Card>
                <Card.Body>
                    <h3 className="flex gap-2 items-center">
                        <FaArrowLeft className="cursor-pointer font-normal" onClick={() => setTarget("info")}/>
                        E-mail
                    </h3>

                    <div className="pt-[15px] px-[15px] mt-2 w-full">
                        <InputForm
                            id="emaol"
                            value={state}
                            onChange={handleInput}
                            label="E-mail *"
                            labelClass={state ? validated ? "!text-[#00b74a]" : "!text-[#f93154]" : ""}
                            inputClass={state ? validated ? "!border-[#00b74a]" : "!border-[#f93154]" : ""}
                        />
                    </div>

                    <div className="flex justify-end p-[15px]">
                        <Button onClick={start_submit} disabled={validated || (!state || showHash)}>
                            Validar
                        </Button>
                    </div>
                </Card.Body>
            </Card>

            <Card hidden={!showHash}>
                <Card.Body>
                    <h3 className="text-center">Validar e-mail</h3>

                    <div className="text-center mb-4">
                        Insira o código de 6 dígitos enviado para:
                        <br/>
                        <b>{state}</b>
                    </div>

                    <div className="py-0 px-[60px]">
                        <div className="flex justify-center items-center mb-4">
                            <div className="flex flex-row gap-3">
                                {[...Array(6)].map((_, index) => (
                                    <input
                                        key={index}
                                        className="code form-control uppercase w-[35px] h-[35px] rounded-md px-2.5 border border-gray-300 focus:outline-[#1266f1]"
                                        type="text"
                                        maxLength="1"
                                        required
                                        autoFocus={index === 0}
                                        ref={(el) => hashRef.current[index] = el}
                                        onInput={(e) => HandleHashInput(e, index, hashRef)}
                                        onPaste={(e) => HandleHashPaste(e, hashRef)}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>

                    <span className="flex gap-2 justify-center text-[#063A6C] text-[13px] mt-3" ref={resendBtn}>
                        <FaEnvelope/>
                        Não recebeu o código?
                        <span ref={resendCode}>Reenviar</span>
                        <span ref={timerEl}></span>
                    </span>

                    <div className="flex justify-center mt-8">
                        <Button className="w-1/4" onClick={submit} actionFeedbackType='save'>
                            Concluir
                        </Button>
                    </div>
                </Card.Body>
            </Card>
        </>
    );
};

export default MyUserEmail;